/* Details Bar Mobile Component JS File */

// close the details bar if pressed outside of the menu
window.closeMenuBarOnDocument = function(e) {
	if ($('body').hasClass('details-bar-menu-open')) {
		if (!$(e.target).parents("#details-bar-menu-mobile").length && !$(e.target).parents(".details-trigger-wrapper").length && !$(e.target).parents(".change-location-trigger-mobile").length) {
			$('body').removeClass('details-bar-menu-open');
			$(".details-bar-menu").removeClass('menu-open');
		}
	}
};

window.closeMenuBar = function() {
	$('body').removeClass('details-bar-menu-open');
	$(".details-bar-menu").removeClass('menu-open');
};

$(document).on('click', function(e) {
	closeMenuBarOnDocument(e);
});

// close the location select bar if pressed outside of the menu
window.closelocationSelectBarOnDocument = function(e) {
	if ($('body').hasClass('details-bar-location-menu-open')) {
		if (!$(e.target).parents(".details-bar-menu-location-select").length && !$(e.target).parents(".details-trigger-wrapper").length && !$(e.target).parents(".change-location-trigger-mobile").length) {
			$('body').removeClass('details-bar-location-menu-open');
			$(".details-bar-menu-location-select").removeClass('menu-open');
		}
	}
};

window.closelocationSelectBar = function() {
	$('body').removeClass('details-bar-location-menu-open');
	$(".details-bar-menu-location-select").removeClass('menu-open');
};

$(document).on('click', function(e) {
	closelocationSelectBarOnDocument(e);
});

window.openLocationsSelectBar = function() {
	$('body').toggleClass('details-bar-location-menu-open');
	// If GeoLocation is not available hide any geo triggers
	if ("geolocation" in navigator === false) {
		jQuery('.section-search').addClass('d-none');
	} else {
		navigator.geolocation.getCurrentPosition(
			function(position) {

			},
			function(error) {
				jQuery('.section-search').addClass('d-none');
			}
		);
	}
	$(".details-bar-menu-location-select").toggleClass('menu-open');
};

window.openMenuBar = function() {
	$('body').toggleClass('details-bar-menu-open');
	$(".details-bar-menu").toggleClass('menu-open');
};

// open the mobile locations drop down
$(window).on('load', function() {

	$(".change-location-trigger-mobile").on('click', function() {
		closeMenuBar();
		openLocationsSelectBar();
	});

	$(".trigger-mobile-dropdown").on('click', function() {
		closelocationSelectBar();
		openMenuBar();
	});
});

$(".location-auto-select-trigger").on("click", function() {
	const $this = $(this);
	$this.addClass('searching');
	setLocation('', function() {
		locationUpdated();
		$this.removeClass('searching');
		$(".details-bar-menu-location-select").removeClass('menu-open');
	});
});

$(".location-select-trigger").on("click", function() {
	const location_id = $(this).data('location-id');
	$('.section-active').removeClass('active');
	$(this).children('.section-active').addClass('active');
	setTimeout(function() {
		closelocationSelectBar();
	}, 500);
	setLocation(location_id, function() {
		locationUpdated();
	});
});
